import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=ac80bd10&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=ts&"
export * from "./MainHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=ac80bd10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac80bd10",
  null
  
)

export default component.exports